module.exports = '<detail-page></detail-page>';